import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';

@Injectable()
export class MensajesService {

  
  constructor(private http:HttpClient, private auth:AuthService) {}

  getMensajesEnviados(usuario, pagina, ordenacion){

    
    if(usuario.CLnombre && !usuario.hasOwnProperty('CLservicio_laboral')){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/clientes/mensajesenviados/${usuario.CLcodigo}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`)
      .map(resp=>{
        
        return resp;
      });

    }else if(usuario.UScodigo==this.auth.usuarioActivo.UScodigo && this.auth.esAdmin()){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/usuarios/mensajesenviados/${usuario.UScodigo}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`)
      .map(resp=>{
        
        return resp;
      });

    }else if(usuario.INnombre){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/intervinientes/mensajesenviados/${usuario.INcodigo}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`)
      .map(resp=>{
        
        return resp;
      });

    }else if(usuario.CLnombre && usuario.hasOwnProperty('CLservicio_laboral')){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/clientes_pymes/mensajesenviados/${usuario.CLcodigo}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`)
      .map(resp=>{
        
        return resp;
      });

    }else if(usuario.UScodigo==this.auth.usuarioActivo.UScodigo && this.auth.esAdminPymes()){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/usuarios/mensajesenviadosPymes/${usuario.UScodigo}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`)
      .map(resp=>{
        
        return resp;
      });
    }
    
  }

  getMensajesRecibidos(usuario, pagina, ordenacion){
    
    if(usuario.CLnombre && !usuario.hasOwnProperty('CLservicio_laboral')){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/clientes/mensajesrecibidos/${usuario.CLcodigo}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`)
      .map(resp=>{
        
        return resp;
      });

    }else if(usuario.UScodigo==this.auth.usuarioActivo.UScodigo && this.auth.esAdmin()){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/usuarios/mensajesrecibidos/${usuario.UScodigo}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`)
      .map(resp=>{
        
        return resp;
      });

    }else if(usuario.INnombre){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/intervinientes/mensajesrecibidos/${usuario.INcodigo}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`)
      .map(resp=>{
        
        return resp;
      });

    }else if(usuario.CLnombre && usuario.hasOwnProperty('CLservicio_laboral')){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/clientes_pymes/mensajesrecibidos/${usuario.CLcodigo}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`)
      .map(resp=>{
        
        return resp;
      });

    }else if(usuario.UScodigo==this.auth.usuarioActivo.UScodigo && this.auth.esAdminPymes()){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/usuarios/mensajesrecibidosPymes/${usuario.UScodigo}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`)
      .map(resp=>{
        
        return resp;
      });
    }
  }

  getMensajesNoLeidos(usuario, ordenacion){

    if(this.auth.esCliente()){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/clientes/mensajesNoLeidos/${usuario.CLcodigo}/${ordenacion.campo}/${ordenacion.orden}`)
      .map(resp=>{
        return resp;
      });
    }else if(this.auth.esAdmin()){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/usuarios/mensajesNoLeidos/${usuario.UScodigo}/${ordenacion.campo}/${ordenacion.orden}`)
      .map(resp=>{
        return resp;
      });
    }else if(this.auth.esInterviniente()){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/intervinientes/mensajesNoLeidos/${usuario.INcodigo}/${ordenacion.campo}/${ordenacion.orden}`)
      .map(resp=>{
        return resp;
      });

    }else if(this.auth.esClientePymes()){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/clientes_pymes/mensajesNoLeidos/${usuario.CLcodigo}/${ordenacion.campo}/${ordenacion.orden}`)
      .map(resp=>{
        return resp;
      });

    }else if(this.auth.esAdminPymes()){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/usuarios/mensajesNoLeidosPymes/${usuario.UScodigo}/${ordenacion.campo}/${ordenacion.orden}`)
      .map(resp=>{
        
        return resp;
      });
    }
  }

  eliminarMensajeRecibido(codigo){
    if(this.auth.esAdmin()){
      return this.http.delete(`https://app.solucionlegal.es/API/index.php/usuarios/mensajerecibido/${codigo}`)
      .map(resp=>{
        return resp;
      });
    }else if(this.auth.esCliente()){
      return this.http.delete(`https://app.solucionlegal.es/API/index.php/clientes/mensajerecibido/${codigo}`)
      .map(resp=>{
        return resp;
      });
    }else if(this.auth.esInterviniente()){
      return this.http.delete(`https://app.solucionlegal.es/API/index.php/intervinientes/mensajerecibido/${codigo}`)
      .map(resp=>{
        return resp;
      });
    }else if(this.auth.esAdminPymes()){
      return this.http.delete(`https://app.solucionlegal.es/API/index.php/usuarios/mensajerecibidoPyme/${codigo}`)
      .map(resp=>{
        return resp;
      });
    }else if(this.auth.esClientePymes()){
      return this.http.delete(`https://app.solucionlegal.es/API/index.php/clientes_pymes/mensajerecibido/${codigo}`)
      .map(resp=>{
        return resp;
      });
    }
  }

  marcarMensajeLeido(codMensaje){
    return this.http.post(`https://app.solucionlegal.es/API/index.php/clientes/marcarMensajeLeido`, {codMensaje})
    .map(resp=>{
      
      return resp;
    });
  }

  eliminarMensajeEnviado(codigo){
    
    if(this.auth.esAdmin()){
      return this.http.delete(`https://app.solucionlegal.es/API/index.php/usuarios/mensajeenviado/${codigo}`)
      .map(resp=>{
        return resp;
      });
    }else if(this.auth.esCliente()){
      return this.http.delete(`https://app.solucionlegal.es/API/index.php/clientes/mensajeenviado/${codigo}`)
      .map(resp=>{
        return resp;
      });
    }else if(this.auth.esInterviniente()){
      return this.http.delete(`https://app.solucionlegal.es/API/index.php/intervinientes/mensajeenviado/${codigo}`)
      .map(resp=>{
        return resp;
      });
    }else if(this.auth.esAdminPymes()){
      return this.http.delete(`https://app.solucionlegal.es/API/index.php/usuarios/mensajeenviadoPyme/${codigo}`)
      .map(resp=>{
        return resp;
      });
    }else if(this.auth.esClientePymes()){
      return this.http.delete(`https://app.solucionlegal.es/API/index.php/clientes_pymes/mensajeenviado/${codigo}`)
      .map(resp=>{
        return resp;
      });
    }
  }


  eliminarMensajeRecibidoCliente(codigo){
    return this.http.delete(`https://app.solucionlegal.es/API/index.php/clientes/mensajerecibidoCliente/${codigo}`)
    .map(resp=>{
      return resp;
    });
  }

  eliminarMensajeEnviadoCliente(codigo){
    return this.http.delete(`https://app.solucionlegal.es/API/index.php/clientes/mensajeenviadoCliente/${codigo}`)
    .map(resp=>{
      return resp;
    });
  }

  eliminarMensajeRecibidoClientePymes(codigo){
    return this.http.delete(`https://app.solucionlegal.es/API/index.php/clientes_pymes/mensajerecibidoCliente/${codigo}`)
    .map(resp=>{
      return resp;
    });
  }

  eliminarMensajeEnviadoClientePymes(codigo){
    return this.http.delete(`https://app.solucionlegal.es/API/index.php/clientes_pymes/mensajeenviadoCliente/${codigo}`)
    .map(resp=>{
      return resp;
    });
  }

  getMensaje(codMensaje){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/clientes/mensaje/${codMensaje}`)
    .map(resp=>{
      return resp;
    })
  }

  getAdjuntos(codMensaje){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/clientes/adjuntosMensaje/${codMensaje}`)
    .map(resp=>{
      return resp;
    })
  }

  insertAdjuntoMensaje(adjunto, archivo){

    let formData:FormData=new FormData();
    
    formData.append("filekey", archivo, archivo.name);
    formData.append("adjunto", JSON.stringify(adjunto));

    return this.http.post(`https://app.solucionlegal.es/API/index.php/clientes/insertAdjuntoMensaje`, formData)
    .map(resp=>{
      return resp;
    })
  }
  
  insertAdjuntoMensajeMasivo(adjunto, archivo, idsCreados){

    let formData:FormData=new FormData();
    
    formData.append("filekey", archivo, archivo.name);
    formData.append("adjunto", JSON.stringify(adjunto));
    formData.append("ids_creados", JSON.stringify(idsCreados));

    return this.http.post(`https://app.solucionlegal.es/API/index.php/clientes/insertAdjuntoMensajeMasivo`, formData)
    .map(resp=>{
      return resp;
    })
  }

  enviarMensaje(mensaje, nombreArchivo){

    let formData:FormData=new FormData();
      formData.append("mensaje", JSON.stringify(mensaje));
      formData.append("nombreAdjunto", nombreArchivo);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/clientes/insertMensaje`,formData )
    .map(resp=>{
      return resp;
    })
  }

  enviarMensajeVariosClientes(clientes, mensaje, nombreArchivo, archivo=null){
    let formData:FormData=new FormData();
    
    if(archivo){
      formData.append("filekey", archivo, archivo.name);
    } 
      formData.append("clientes", JSON.stringify(clientes));
      formData.append("mensaje", JSON.stringify(mensaje));
    return this.http.post(`https://app.solucionlegal.es/API/index.php/clientes/EnviarMensajeVariosClientes`,formData )
    .map(resp=>{
      
      return resp;
    })
  }

  enviarMensajeVariosClientesPymes(clientes, mensaje, nombreArchivo, archivo=null){
    let formData:FormData=new FormData();
    
    if(archivo){
      formData.append("filekey", archivo, archivo.name);
    } 
      formData.append("clientes", JSON.stringify(clientes));
      formData.append("mensaje", JSON.stringify(mensaje));
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/EnviarMensajeVariosClientesPymes`,formData )
    .map(resp=>{
      
      return resp;
    })
  }
  subirArchivo(archivo){
    
    let formData=new FormData();
    formData.append('filekey', archivo, archivo.name)
    return this.http.post(`https://app.solucionlegal.es/API/index.php/clientes/insertMensaje`,formData )
    .map(resp=>{
      
      return resp;
    })
  }

  descargarAdjunto(adjunto){

    let body= JSON.stringify(adjunto);

    return this.http.post(`https://app.solucionlegal.es/API/index.php/clientes/descargarAdjuntoMensaje`, body, {responseType:'arraybuffer'})
    .map(res=>new Blob([res],{ type: 'application/pdf'}));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/mensajes.service.ts